var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFermerLaPorte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.501 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.5)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 881",
    d: "M88.5 63.5H78.251V7.75A6.257 6.257 0 0 0 72 1.5H44.876a6.257 6.257 0 0 0-6.25 6.25V63.5H0v-3h35.626V7.75a9.248 9.248 0 0 1 9.25-9.25H72a9.26 9.26 0 0 1 9.25 9.25V60.5h7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 883",
    d: "M75.669 61.743H41.112V7.713a3.383 3.383 0 0 1 3.391-3.37h27.778a3.383 3.383 0 0 1 3.388 3.37Zm-32.554-2h30.554V7.713a1.381 1.381 0 0 0-1.388-1.37H44.503a1.381 1.381 0 0 0-1.391 1.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2445",
    width: 10.37,
    height: 3.457,
    rx: 1,
    transform: "translate(60.99 33.176)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermerLaPorte);
export default __webpack_public_path__ + "static/media/fermer-la-porte.18a0494bde694ba9116f6c1ff4cd13c6.svg";
export { ForwardRef as ReactComponent };